import { beginOperation as d, normaliseOperationName as R } from "./operations.helper.js";
var m = [], t = null, i = null, l = null, h = (e) => {
  if (process.env.NODE_ENV !== "production") throw new Error(e);
  console.warn(e);
}, p = (e) => {
  const n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Map();
  e.forEach((a) => {
    R(a.name), n.has(a.name) && h(`Duplicate journey name "${a.name}".`), n.add(a.name), a.entryRoutes.length === 0 && h(`Journey "${a.name}" has no entry routes.`), a.entryRoutes.forEach((o) => {
      const u = r.get(o);
      u && h(`Route "${o}" is an entry route for both "${u}" and "${a.name}". The journey that starts would be ambiguous.`), r.set(o, a.name), a.successRoutes?.includes(o) && h(`Route "${o}" is both an entry and a success route of "${a.name}", which would make the journey self-completing.`);
    });
  });
}, J = (e) => {
  p(e), m.length = 0, m.push(...e);
}, O = () => {
  m.length = 0;
}, j = () => {
  m.length = 0, t = null, i = null, l = null;
}, E = () => t?.definition.name ?? null, g = (e) => {
  const n = e?.name;
  return typeof n == "string" && n.length > 0 ? n : void 0;
}, w = (e) => {
  const n = (e.matched ?? []).map(g).filter((r) => r !== void 0);
  return typeof e.name == "string" && e.name && !n.includes(e.name) && n.push(e.name), n;
}, c = (e, n) => !!n?.some((r) => e.includes(r)), x = (e, n) => {
  t = {
    definition: e,
    handle: d(e.name, {
      description: e.description,
      context: {
        ...e.context,
        entryRoute: n
      }
    }),
    lastRouteId: n,
    context: l ?? {}
  }, l = null;
}, b = (e, n) => `${e.path ?? ""}|${n.join(">")}`, N = (e) => {
  const n = w(e), r = b(e, n);
  if (r === i) return;
  i = r;
  const a = n[n.length - 1] ?? "unknown";
  let o = null;
  if (t) {
    const { definition: s, handle: v, lastRouteId: f, context: y } = t;
    if (c(n, s.successRoutes))
      v.succeed({
        ...y,
        exitRoute: a
      }), t = null, o = s.name;
    else if (c(n, s.entryRoutes) && s.onReentry === "restart")
      v.fail("abandoned", {
        ...y,
        reasonDetail: "restarted",
        lastRoute: f
      }), t = null;
    else if (c(n, s.entryRoutes) || c(n, s.stepRoutes)) {
      t.lastRouteId = a;
      return;
    } else
      v.fail("abandoned", {
        ...y,
        lastRoute: f,
        exitRoute: a
      }), t = null;
  }
  const u = m.find((s) => s.name !== o && c(n, s.entryRoutes));
  u && x(u, a);
}, C = (e) => {
  if (t) {
    Object.assign(t.context, e);
    return;
  }
  if (l) {
    Object.assign(l, e);
    return;
  }
  const n = { ...e };
  l = n, queueMicrotask(() => {
    l === n && (l = null);
  });
}, k = (e) => {
  t && (t.handle.succeed({
    ...t.context,
    completion: "manual",
    ...e
  }), t = null, i = null);
}, A = (e, n) => {
  t && (t.handle.fail(e, {
    ...t.context,
    lastRoute: t.lastRouteId,
    ...n
  }), t = null, i = null);
};
export {
  j as clearJourneys,
  A as failActiveJourney,
  E as getActiveJourneyName,
  N as handleRouteChange,
  J as registerJourneys,
  C as setJourneyContext,
  k as succeedActiveJourney,
  O as unregisterJourneys
};

//# sourceMappingURL=journeyTracker.js.map